import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class DocumentosJsonService {
  private apiUrl = environment.apiUrl;
  documentosUrl = `${this.apiUrl}public/documentos-json/`;

  constructor(private _http: HttpClient) {
  }

  getDocumentosEmpresaTipo(empresaId, tipo): Observable<any[]> {
    return this._http.get(`${this.documentosUrl}${empresaId}/tipos/${tipo}`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getDocumentoEmpresaId(empresaId, id): Observable<any[]> {
    return this._http.get(`${this.documentosUrl}${empresaId}/documentos/ids/${id}`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getDocumentoNomeEmpresa(empresaId, nome): Observable<any[]> {
    return this._http.get(`${this.documentosUrl}${empresaId}/documentos/nomes/${nome}`)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  insertDocumentoEmpresaTipoNome(empresaId, documento): Observable<{}> {
    return this._http.post(`${this.documentosUrl}${empresaId}`, documento)
      .pipe(map((data) => {
        return <{}>data;
      }));
  }
}
